'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = formatDate;
function formatDate(timestamp) {
  var currentDate = new Date(timestamp);
  var date = ('0' + currentDate.getDate()).substr(-2);
  var month = ('0' + (currentDate.getMonth() + 1)).substr(-2);
  var year = currentDate.getFullYear();
  return String(date) + '.' + String(month) + '.' + String(year);
}